export const selectItems = (state) => state.items.categories;
export const selectItemsLoading = (state) => state.items.loading;
export const selectItemsError = (state) => state.items.error;

// Helper selector to get category by name
export const selectCategoryByName = (state, categoryName) => {
  const categories = selectItems(state);
  return categories.find(
    (cat) => cat.CategoryName?.toLowerCase() === categoryName?.toLowerCase()
  );
};

// Helper selector to get brands for a category
export const selectBrandsByCategory = (state, categoryName) => {
  const category = selectCategoryByName(state, categoryName);
  return category?.Brand || [];
};

